function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { Form, Button } from 'semantic-ui-react';

var RegisterForm = function (_React$Component) {
  _inherits(RegisterForm, _React$Component);

  function RegisterForm(props) {
    _classCallCheck(this, RegisterForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleInputChange = function (event) {
      var formData = Object.assign({}, _this.state.formData);
      formData[event.target.name] = event.target.value;

      _this.setState({
        formData: formData
      });
    };

    _this.state = {
      formData: {
        name: '',
        phoneNumber: '',
        password: '',
        passwordConfirmation: ''
      }
    };
    return _this;
  }

  RegisterForm.prototype.render = function render() {
    var _props = this.props,
        handleSubmit = _props.handleSubmit,
        isFetching = _props.isFetching;
    var _state$formData = this.state.formData,
        name = _state$formData.name,
        phoneNumber = _state$formData.phoneNumber,
        password = _state$formData.password,
        passwordConfirmation = _state$formData.passwordConfirmation;
    var passwordTipStyle = {
      fontSize: '11px'
    };
    return React.createElement(Form, {
      onSubmit: function onSubmit() {
        handleSubmit(name, phoneNumber, password);
      },
      className: 'register-form__form'
    }, React.createElement(Form.Input, {
      label: 'Name',
      name: 'name',
      type: 'text',
      onChange: this.handleInputChange,
      disabled: isFetching
    }), React.createElement(Form.Input, {
      label: 'Phone Number',
      name: 'phoneNumber',
      type: 'text',
      onChange: this.handleInputChange,
      disabled: isFetching
    }), React.createElement(Form.Input, {
      label: 'Password',
      name: 'password',
      type: 'password',
      onChange: this.handleInputChange,
      disabled: isFetching
    }), React.createElement('p', {
      style: passwordTipStyle
    }, 'Passwords must be at least eight characters in length, and must include one uppercase letter, one lowercase letter, and one numeric character'), React.createElement(Form.Input, {
      label: 'Confirm Password',
      name: 'passwordConfirmation',
      type: 'password',
      onChange: this.handleInputChange,
      disabled: isFetching
    }), React.createElement('div', null, React.createElement(Button, {
      disabled: password !== passwordConfirmation || password === '' ? true : false,
      type: 'submit',
      loading: isFetching
    }, 'Register')));
  };

  return RegisterForm;
}(React.Component);

export default RegisterForm;